const p = 'http://www.w3.org/2001/XMLSchema#';
const xsd = {
    xboolean: p + 'boolean',
    xint: p + 'int',
    xinteger: p + 'integer',
    xlong: p + 'long',
    decimal: p + 'decimal',
    xfloat: p + 'float',
    xdouble: p + 'double',
    xstring: p + 'string',
    date: p + 'date',
    dateTime: p + 'dateTime'
};

export default xsd;